















































































import { Vue, Component } from "nuxt-property-decorator";
import GrPublicFooter from "~/components/startPageNew/GrPublicFooter.vue";

// import gsap from "gsap";

@Component({
  components: { GrPublicFooter },
})
export default class SiteMapPage extends Vue {
  getLink(v: { name: string; noLocale?: boolean }): string | { name: string } {
    if (v.noLocale) {
      return { name: v.name };
    }

    return this.localePath({ name: v.name });
  }

  get sites() {
    return [
      {
        name: "index",
        title: this.$t("Start").toString(),
      },
      {
        name: "talentStart",
        title: this.$t("För talanger").toString(),
      },
      {
        name: "companyStart",
        title: this.$t("För företag").toString(),
      },
      {
        name: "companyStart-applyforcompanyaccount",
        title: this.$t("Ansök om företagskonto").toString(),
      },
      {
        name: "termsofuse",
        title: this.$t("Användarvillkor").toString(),
      },
      {
        name: "privacypolicy",
        title: this.$t("Integritetspolicy").toString(),
      },
      {
        name: "cookies",
        title: this.$t("Cookies").toString(),
      },
      {
        name: "aboutgritify",
        title: this.$t("Om oss").toString(),
      },
      {
        name: "talentStart-createProfileStart",
        title: this.$t("Skapa konto").toString(),
      },
      {
        noLocale: true,
        name: "rekryteringsforetag",
        title: "Rekryteringsföretag",
      },
      {
        noLocale: true,
        name: "rekryteringsforetag-IT",
        title: "Rekryteringsföretag - IT",
      },
      {
        noLocale: true,
        name: "rekryteringsforetag-stockholm",
        title: "Rekryteringsföretag - Stockholm",
      },
      {
        noLocale: true,
        name: "rekryteringsforetag-goteborg",
        title: "Rekryteringsföretag - Göteborg",
      },
      {
        noLocale: true,
        name: "rekryteringsforetag-malmo",
        title: "Rekryteringsföretag - Malmö",
      },
      {
        noLocale: true,
        name: "it-jobb",
        title: "IT jobb",
      },
      {
        noLocale: true,
        name: "it-jobb-stockholm",
        title: "IT jobb - Stockholm",
      },
      {
        noLocale: true,
        name: "it-jobb-goteborg",
        title: "IT jobb - Göteborg",
      },
      {
        noLocale: true,
        name: "it-jobb-malmo",
        title: "IT jobb - Malmö",
      },
      {
        noLocale: true,
        name: "ingenjorsjobb",
        title: "Ingenjörsjobb",
      },
      {
        noLocale: true,
        name: "ingenjorsjobb-stockholm",
        title: "Ingenjörsjobb - Stockholm",
      },
      {
        noLocale: true,
        name: "ingenjorsjobb-goteborg",
        title: "Ingenjörsjobb - Göteborg",
      },
      {
        noLocale: true,
        name: "ingenjorsjobb-malmo",
        title: "Ingenjörsjobb - Malmö",
      },
      {
        noLocale: true,
        name: "rekrytera-ingenjorer",
        title: "Rekrytera ingenjörer",
      },
      {
        noLocale: true,
        name: "rekrytera-utvecklare",
        title: "Rekrytera utvecklare",
      },
      {
        noLocale: true,
        name: "rekrytera-jurister",
        title: "Rekrytera jurister",
      },
    ];
  }

  head() {
    return {
      title: this.$t("Sitemap").toString(),
    };
  }

  get blogPosts(): { title: string; slug: string }[] {
    return [
      {
        title: "Vad är employer branding?",
        slug: "vad-ar-employer-branding",
      },
      {
        title: "Vad kostar en rekrytering?",
        slug: "vad-kostar-en-rekrytering",
      },
      {
        title: "Rekrytera utvecklare med Gritify",
        slug: "rekrytera-utvecklare",
      },
      {
        title: "Rekrytera fördomsfritt",
        slug: "rekrytera-fordomsfritt",
      },
      {
        title: "Kompetensbaserad rekrytering",
        slug: "kompetensbaserad-rekrytering",
      },
      {
        title: "Skriva jobbannons",
        slug: "skriva-jobbannons",
      },
      {
        title: "Lyckat samarbete mellan Gritify och Dagens Industri",
        slug: "lyckat-samarbete-mellan-gritify-och-dagens-industri",
      },
    ];
  }
}
